import { SearchTerm } from './SearchTerm';

const TimeZoneSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "zone",
        translationKey: "name"
    }
];

export default TimeZoneSearch;
